module.exports = __webpack_public_path__ + "static/media/46.e33bb02d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/res/thumbnails/46.jpg
// module id = 990
// module chunks = 0